module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAUCAIAAADz4NHXAAABJ0lEQVQ4y2P4T23AMGoiHvD7928qm9jdWkA1E29eP1tRnubhpAEkgWxKTfz79+/xwxsrs03yM7UD3TWOHlz/798/8k0Ehl1mbcHBvRu8nGSntnsGeSseOLDdLMnlzoO7ZJrYPW9iTEFyWICGdVyoZGKbdWRQfraJV6r//E3L8JnI0HQRO6o5zBCSxGps5xpkoe0WZeSTrOUeEZfvwuFiwxBozZA3F6dGnBKNFxg8opgsjfwSrOV8NdgsFbSc5MOzrLhM9BmiYnHqwmdiwzkG70QuGxcFY/PULH15M8HMdB0+Y2VWJyOWxCqyTKw/wxDToJ83KadrRkBoeFC4W2Z+sX9OpUBSPkNaJVkmwpBI+RbNgHTR6BZt3yTW+lME1RM2kWQ0aiJVEADCGUrIpozXBAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./client/src/images/flags/sm.png
// module id = 928
// module chunks = 0